import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';
import * as actionTypes from './actionTypes';

const initialState = {
  spaces: {},
  tags: {},
  folders: {},
  files: {},
  documents: {},
  users: {},
  roles: {},
  dashboards: {},
  aclObjectIdentities: {},
  aclSids: {},
};

// Do not merge arrays but replace them with the new value instead
// This avoids inconsistencies when for example removing related child entities from a parent
// eslint-disable-next-line
function mergeCustomizer(objValue, srcValue) {
  if (isArray(objValue)) {
    return srcValue;
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUCCESS:
      return mergeWith({}, state, action.entities, mergeCustomizer);
    default:
      return state;
  }
};
